// extracted by mini-css-extract-plugin
module.exports = {"duplicateAndEditText":"_3EFjH","editRoleButton":"_2j6Pe"};